import { axiosBase } from '@/plugins/axios'

export class Files {
  uploadSignFile(data) {
    return axiosBase
      .post(`/v2/projects/project-point/upload-attach`, data)
      .then((response) => response.data)
  }

  saveSignFile(id, params) {
    return axiosBase.post(`/v2/projects/project-point/sign-attach`, {
      id,
      ...params,
    })
  }

  getFileByPointId(pointId) {
    return axiosBase
      .get(`/v2/projects/project-point/list-attach?filter[pointId]=${pointId}`)
      .then((response) => response.data)
  }

  getSignedFiles(requestParams) {
    const params = requestParams ? new URLSearchParams({ ...requestParams }).toString() : ''
    return axiosBase
      .get(`/v2/projects/project-point/list-attach?${params}`)
      .then((response) => response.data)
  }

  _poll(requestFn, conditionFn, maxAttempts = 10, interval = 3000) {
    return (async () => {
      let attempt = 0
      while (attempt < maxAttempts) {
        const response = await requestFn()
        if (conditionFn(response)) return response
        attempt++
        if (attempt < maxAttempts) {
          await new Promise((r) => setTimeout(r, interval))
        }
      }
      throw new Error('Превышено время ожидания')
    })()
  }

  getLinkProject(id) {
    return this._poll(
      () => axiosBase.get(`/v2/projects/project-point/zip/${id}/link`).then((res) => res.data),
      (data) => !!data?.link,
    )
  }

  downloadZipProject(id) {
    return axiosBase
      .get(`/v2/projects/project-point/zip/${id}`, { responseType: 'blob' })
      .then((response) => response.data)
  }

  getBase64File(id) {
    return axiosBase
      .get(`/v2/projects/project-point/download-attach/${id}`, { responseType: 'blob' })
      .then((response) => response.data)
  }

  getLinkFile(id) {
    return axiosBase
      .get(`/v2/projects/project-point/download-attach/${id}/link`)
      .then((response) => response.data)
  }

  downloadProgramFile(id) {
    return axiosBase.get(`/v2/projects/download-file/${id}`).then((response) => response.data)
  }

  deleteSignedFile(id) {
    return axiosBase
      .delete(`/v2/projects/project-point/delete-attach/${id}`)
      .then((response) => response.data)
  }

  getUploadUrl(data) {
    return axiosBase
      .post(`/v2/projects/project-point/upload-url`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => response.data)
  }

  confirmUpload(attacheId) {
    return axiosBase
      .post(`/v2/projects/project-point/upload-confirm/${attacheId}`)
      .then((response) => response.data)
  }
}
